import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IAppWrapper, IMediaQuery } from "src/ScrollyInterface";
import { breakpoints } from "src/shared/breakpoints";
import * as actions from "src/store/actions/index";
import { ISetActiveBreakpoint } from "src/store/StoreInterface";

class AppWrapper extends React.Component<IAppWrapper, {}> {
  private mediaQueryState: IMediaQuery[];
  private breakpointChange: () => void;
  constructor(props: IAppWrapper) {
    super(props);
    this.mediaQueryState = [];
  }

  public componentDidMount() {
    this.breakpointChange = () => {
      this.dispatchActiveQuery();
    };

    for (const breakpoint of breakpoints) {
      const query = breakpoint.query;
      const mediaQuery = { ...breakpoint };
      query.addListener(this.breakpointChange.bind(this));
      this.mediaQueryState.push(mediaQuery);
    }

    this.dispatchActiveQuery();
  }

  public componentWillUnmount() {
    for (const breakpoint of breakpoints) {
      const query = breakpoint.query;
      query.removeListener(this.breakpointChange.bind(this));
    }
  }

  public dispatchActiveQuery = () => {
    const activeQuery = this.mediaQueryState.reduce(
      (prev: IMediaQuery, curr: IMediaQuery): IMediaQuery => {
        return curr.query.matches ? curr : prev;
      }
    );
    const breakpointName = activeQuery ? activeQuery.name : "default";
    this.props.onSetActiveBreakpoint(breakpointName);
  };

  public render() {
    return <div>{this.props.children}</div>;
  }
}

const mapDispatchToProps = (dispatch: Dispatch<ISetActiveBreakpoint>) => {
  return {
    onSetActiveBreakpoint: (breakpointName: string) =>
      dispatch(actions.setActiveBreakpoint(breakpointName))
  };
};

export default connect(
  null,
  mapDispatchToProps
)(AppWrapper);



// WEBPACK FOOTER //
// ./src/HOC/AppWrapper.tsx